import React, {Component} from 'react';
import '../../App.css';
// import {TableColumnPopupType} from '../Popup/TableColumnPopup';
// import { getLocalisedText } from '../../Translate/LanguageManager';
// import AppManager from '../../Manager/AppManager';
// import Utility from '../../Utilities/Utility';

import {
    Utility,
    AppManager,
    getLocalisedText,
    TableColumnPopupType
} from 'deskera-doc-builder-lib';
export default class PackingColumnEditor extends Component {

    dataChanged(data) {
        this.props.dataChanged(this.props.data);
    }

    render() {
        return this.getPackingListColumns(this.props.columnData)
    }

    getPackingListColumns(columnsData = []) {
        var arr = [];
        for (let i = 0; i < columnsData.length; i++) {
            arr.push(this.getPackingListColumn(i, columnsData[i]));
        }
        return arr;
    }

    getPackingListColumn(index, columnData) {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "flex-start",
                }}
            >
                {this.getShowHideValueForTablePopup(TableColumnPopupType.code) && this.getColumnTextfields(
                    "product_code",
                    index,
                    columnData.code,
                    this.columnCodeChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.productName) && this.getColumnTextfields(
                    "product_name",
                    index,
                    columnData.name,
                    this.columnNameChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.barcode) && this.getColumnTextfields(
                    "barcode",
                    index,
                    columnData.barcode,
                    this.columnBarcodeChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.unit) && this.getColumnTextfields(
                    "unit",
                    index,
                    columnData.unit,
                    this.columnUnitChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.serialBatch) && this.getColumnTextfields(
                    "serial_batch",
                    index,
                    columnData.serialBatch,
                    this.columnSerialBatchChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.packedQuantity) && this.getColumnTextfields(
                    "packed_quantity",
                    index,
                    columnData.packedQuantity,
                    this.columnPackedQuantityChanged,
                )}
                <div className='RowDiv'
                    style={{
                        flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row'
                    }}>
                    <button
                        style={{
                            marginTop: 10,
                            cursor: "pointer",
                            color: "red",
                            border: "solid",
                            borderWidth: 1,
                            borderColor: "rgb(210, 210, 210)",
                            backgroundColor: "white",
                            borderRadius: 4,
                            marginBottom: 20,
                        }}
                        onClick={() => this.deleteColumn(index)}
                    >
                        {getLocalisedText("delete")}
                    </button>
                </div>
            </div>
        );
    }

    deleteColumn(index) {
        var data = this.props.data;
        data["lineItems"].splice(index, 1);
        this.dataChanged(data);
    }

    getColumnTextfields(placeholder, index, value, callback) {
        return (
            <input
                className="TextField"
                style={{
                    marginTop: 6,
                    borderRadius: 4,
                    color: 'rgb(30, 30, 30)'
                }}
                placeholder={getLocalisedText(placeholder)}
                type="text"
                dir={Utility.getInputDirection()}
                value={getLocalisedText(value)}
                onChange={(e) => callback(e, index)}
            />
        );
    }

    columnCodeChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["code"] = event.target.value;
        this.dataChanged(data);
    };

    columnNameChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["name"] = event.target.value;
        this.dataChanged(data);
    };

    columnBarcodeChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["barcode"] = event.target.value;
        this.dataChanged(data);
    };

    columnUnitChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["unit"] = event.target.value;
        this.dataChanged(data);
    };

    columnSerialBatchChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["serialBatch"] = event.target.value;
        this.dataChanged(data);
    };

    columnPackedQuantityChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["packedQuantity"] = value;
        this.dataChanged(data);
    };

    getShowHideValueForTablePopup(tableColumnPopupType) {
        var item = AppManager.getTableColumnOptions(this.props.data.tableColumnPopup, tableColumnPopupType)
        if(item === undefined || item  === null) {
            return false
        }
        else {
            return item.isSelected
        }
    }

}
